<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @update="update"
      @openEditPage="openEditPage"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <template>
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openEditPage({ pageType: 'add' })"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('btn_add') || '新增' }}
          </b-button>
          <el-badge
            v-if="allow('U')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              v-if="allow('U')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              :disabled="!checkedRowCount"
              @click="getExpoInfoDate"
            >
              {{ $l('btn_update') || '展会时间变更' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </template>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Detail
      :visible.sync="editExpoInfoOptions.visible"
      :expoInfoCode="editExpoInfoOptions.expoInfoCode"
      :pageType="editExpoInfoOptions.pageType"
      @reload="reload"
    ></Detail>
    <ChangeExpoDate
      v-if="updateExpoDateInfo.updateExpoDateVisible"
      :visible.sync="updateExpoDateInfo.updateExpoDateVisible"
      :expoInfoCode.sync="updateExpoDateInfo.expoInfoCode"
      @confirm="confirmExpoDate"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import Detail from '../../detail'
import ChangeExpoDate from '../change-expo-date'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, Detail, ChangeExpoDate },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      editExpoInfoOptions: {
        pageType: '',
        visible: false,
        expoInfoCode: '',
      },
      updateExpoDateInfo: {
        updateExpoDateVisible: false,
        expoInfoCode: '',
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .expoInfoListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, expoInfoCode }) {
      this.editExpoInfoOptions.pageType = pageType
      this.editExpoInfoOptions.visible = true
      this.editExpoInfoOptions.expoInfoCode = expoInfoCode
    },
    getExpoInfoDate() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l('tips_select_expo_info') || '请选择展会信息',
          type: 'warning',
        })
        return
      }
      if (this.checkedRowCount == 1) {
        const data = this.checkedRows[0]
        this.updateExpoDateInfo.expoInfoCode = data.expoInfoCode
      }
      this.updateExpoDateInfo.updateExpoDateVisible = true
    },
    update({ expoInfoCode }) {
      this.updateExpoDateInfo.expoInfoCode = expoInfoCode
      this.updateExpoDateInfo.updateExpoDateVisible = true
    },
    async confirmExpoDate(form) {
      if (this.loadingOpen()) return
      let listCode = []
      if (!this.checkedRowCount) {
        listCode = [form.expoInfoCode]
      } else {
        listCode = this.checkedRows.map((item) => item.expoInfoCode)
      }
      const res = await this.$api
        .expoInfoChangeDateApi({ listCode, ...form })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_update_fail') || '变更失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_update_success') || '变更成功！',
        type: 'success',
      })
      this.reload()
      this.clearCheckboxRow()
      this.updateExpoDateInfo.expoInfoCode = ''
      this.updateExpoDateInfo.updateExpoDateVisible = false
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
